var _defs, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgSettings(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlSpace: "preserve",
    width: "1600px",
    height: "1600px",
    style: {
      shapeRendering: "geometricPrecision",
      textRendering: "geometricPrecision",
      imageRendering: "optimizeQuality",
      fillRule: "evenodd",
      clipRule: "evenodd"
    },
    viewBox: "0 0 16000000 16000000",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, ".fil0 {fill:#7DCFED}"))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_x0020_1"
  }, /*#__PURE__*/React.createElement("metadata", {
    id: "CorelCorpID_0Corel-Layer"
  }), /*#__PURE__*/React.createElement("g", {
    id: "_643951248"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("circle", {
    className: "fil0",
    cx: 7999787,
    cy: 8323842,
    r: 1503851
  }), /*#__PURE__*/React.createElement("path", {
    className: "fil0",
    d: "M7999787 -59c-4418116,0 -7999799,3581943 -7999799,7999894 0,4417963 3581683,8000224 7999799,8000224 4418116,0 8000224,-3582049 8000224,-8000224 0,-4418164 -3582108,-7999894 -8000224,-7999894zm4203982 9162678l-1136339 73181c-63626,214394 -148417,419516 -253122,612378l751370 855414 -1186406 1186300 -855000 -751524c-192957,104587 -398079,189390 -612366,252862l-73441 1136587 -1677780 -154 -73335 -1136493c-214134,-63461 -419256,-148264 -612213,-252851l-855154 751524 -1186300 -1186678 751359 -854989c-104693,-192969 -189496,-398091 -253122,-612378l-1136327 -73335 0 -1677780 1136327 -73335c63626,-214134 148595,-419410 253122,-612213l-751359 -854989 1186406 -1186571 854989 751370c192969,-104705 398091,-189390 612485,-253016l73335 -1136493 1677461 0 73429 1136493c214252,63626 419421,148264 612378,253016l855260 -751370 1186312 1186571 -751370 854989c104587,192957 189496,398079 253122,612213l1136327 73335 -47 1677934z"
  })))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSettings);
export default __webpack_public_path__ + "static/media/settings.90ddaf087fc78fc84743438099f0deeb.svg";
export { ForwardRef as ReactComponent };